// 营养科普 - 列表
import { useState, useEffect } from "react"
import { Button, Pagination, Spin } from "antd"
import { useSelector } from "react-redux"
import TitleComponent from "@/components/sc/TitleComponent"
import SliderComponent from "@/components/sc/SliderComponent"
import PageFooter from "@/components/sc/PageFooter"
import api from "@/net/api"
import { Link } from "react-router-dom"
import moment from "moment"

import "./list.less"

export default function List(props) {
	const user = useSelector(state => state.sysuserInfo || {})

	const [table, setTable] = useState({ list: [], total: 0 })
	const [page, setPage] = useState(1)
	const PAGE_SIZE = 6
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getList()
	}, [page])

	async function getList() {
		let param = {
			currentPage: page,
			pageSize: PAGE_SIZE,
			orgRegionId: user.buyerOrgId,
			type: "USER",
		}
		setLoading(true)
		try {
			let d = await api.popularization_list(param)
			d.list.forEach(item => {
				item.createTime_ = moment(item.createTime).format("YYYY.MM.DD HH:mm")
			})
			setTable({ list: d.list, total: d.total })
		} catch(e) {
			console.log(e)
		} finally {
			setLoading(false)
		}
	}

	function onPageChange(page) {
		setPage(page)
	}
	function pageItemRender(_, type, originalElement) {
		if (type == "prev") {
			return <Button className="page-button">上一页</Button>
		}
		if (type == "next") {
			return <Button className="page-button">下一页</Button>
		}
		return originalElement
	}

	return <div className="pages_main_nutrition-science_list" style={props.style || {}}>
		<TitleComponent title="" />

		<div className="body-main">
			{loading
			? <Spin className="loading" />
			: <>
				<div className="list">
				{table.list.map((item, i) =>
				<Link className="list-item" key={i} to={"?id=" + item.id}>
					<ImgOrVideo item={item}></ImgOrVideo>
					{/* <img className="item-img" src={ item.absPicUrl } /> */}
					<div className="item-main">
						<div className="item-title">{ item.title }</div>
						<div className="item-time">发布时间: { item.createTime_ }</div>
					</div>
				</Link>
				)}
				</div>
				<Pagination className="pagination" itemRender={pageItemRender} onChange={onPageChange}
					total={table.total} current={page} pageSize={PAGE_SIZE} />
			</>
			}
		</div>
		<SliderComponent style={{ marginTop: "57px" }} />
		<PageFooter style={{ color: "#fff", marginTop: "26px" }} />
	</div>
	
}

function ImgOrVideo({item}){
	let suffix = item.absPicUrl.split('NEWS')[1].split('.')[1].split('?')[0]
	let isVideo = item.absPicUrl.includes('.mp4')||item.absPicUrl.includes('.avi')||item.absPicUrl.includes('.mov')||item.absPicUrl.includes('.flv')
	return (
		isVideo ? <video className='item-img' autoPlay loop controls src={item.absPicUrl} type={"video/"+suffix}></video>
		:
	<img className='item-img' mode="scaleToFill" src={item.absPicUrl} />
	)
	
}